export class AnswerApi {
  constructor(api) {
    this.api = api;
  }

  async sendAnswers(formId, answers) {
    const responses = answers.map((a) => AnswerApi.mapToApi(a)); // remove the inspection not needed in api
    return (
      await this.api('postAnswer', { formId }, null, JSON.stringify({ responses }), {
        'Content-Type': 'application/json',
      })
    ).data;
  }

  static mapToApi({ path, value, questionId, questionType, questionChild, questionChiledType }) {
    let formattedPath = path;
    const arrayPath = path.split('.');
    if (arrayPath.shift() === 'inspection') formattedPath = arrayPath.join('.');
    return {
      value,
      path: formattedPath,
      questionId,
      questionType,
      questionChild,
      questionChiledType,
    };
  }
}
